import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    padding: '2.5rem 0 4rem',
  },
  contentStyles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
